const HANDLED_REJECTION_GUARD_KEY =
  '__coachCatalystHandledRejectionGuardInstalled';

export const markErrorHandledByInterceptor = (error) => {
  if (error && typeof error === 'object') {
    error.handledByInterceptor = true;
  }
};

export const suppressHandledPromiseRejection = (event) => {
  if (!event.reason?.handledByInterceptor) return;

  event.preventDefault();
  event.stopImmediatePropagation();
};

export const installHandledPromiseRejectionGuard = () => {
  if (typeof window === 'undefined' || window[HANDLED_REJECTION_GUARD_KEY]) {
    return;
  }

  window.addEventListener(
    'unhandledrejection',
    suppressHandledPromiseRejection
  );
  window[HANDLED_REJECTION_GUARD_KEY] = true;
};
